import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { Button, Form, Input } from 'antd';
import PhoneInput from 'antd-phone-input';
import css from '@/pages/Login/Login.module.scss';

import LoginWrapper from '../LoginWrapper';

import { subscribeDevice } from '@/utils/pushManager';
import { clearError, mobileUserLogin } from '@shared/store/Auth/actions';
import { selectAuth } from '@shared/store/Auth/selectors';

const AuthorizationMobile = () => {
  const { t } = useTranslation('authMobile');
  const dispatch = useDispatch();
  const [redirectPath, setRedirectPath] = useState('');

  const { error: errorText } = useSelector(selectAuth);

  const mobileValidator = (_, { valid }) => {
    if (valid(true)) return Promise.resolve();
    return Promise.reject(t('rules.phone'));
  };

  const onLoginSuccess = resp => {
    localStorage.setItem('authorizationToken', resp.accessToken);
    localStorage.setItem('refreshToken', resp.refreshToken);
    localStorage.setItem('expiresIn', resp.expiresIn);
    localStorage.setItem('expiresTime', String(resp.expiresIn * 1000 + Date.now()));
    subscribeDevice();
    localStorage.removeItem('authData');

    const redirect = localStorage.getItem('currentRedirect') ? localStorage.getItem('currentRedirect') : '/';
    setRedirectPath(redirect);
  };

  const mobileLogin = ({ phone, password }) => {
    const sendData = {
      username: `+${phone?.countryCode}${phone?.areaCode}${phone?.phoneNumber}`,
      password,
    };

    dispatch(
      mobileUserLogin(sendData, resp => {
        if (!resp.messageId) {
          onLoginSuccess(resp);
          return;
        }

        localStorage.setItem('authData', JSON.stringify(sendData));
        setRedirectPath(`/user-login/mobile/verify/${resp.messageId}`);
      })
    );
  };

  const handleChange = (value, event) => {
    dispatch(clearError());
  };

  if (redirectPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <LoginWrapper type='auth'>
      <Form className={css['LoginPage-form']} layout='vertical' onFinish={mobileLogin}>
        {/* Номер телефона */}
        <Form.Item
          className={css['LoginPage-form-item']}
          name='phone'
          validateTrigger='onBlur'
          validateStatus={errorText?.length > 0 ? 'error' : 'success'}
          help={errorText?.length > 0 && errorText}
          rules={[{ required: true, validator: mobileValidator }]}
        >
          <PhoneInput
            placeholder={t('placeholders.phone')}
            preferredCountries={['ru', 'by']}
            enableSearch
            disableParentheses
            onChange={handleChange}
          />
        </Form.Item>

        {/* Пароль */}
        <Form.Item
          className={css['LoginPage-form-item']}
          name='password'
          rules={[{ required: true, message: t('rules.password') }]}
        >
          <Input.Password className={css['LoginPage-form-item-password']} placeholder={t('placeholders.password')} />
        </Form.Item>

        {/* Кнопка войти */}
        <Form.Item className={css['LoginPage-form-google']}>
          <Button type='primary' htmlType='submit' size='large'>
            {t('login')}
          </Button>
        </Form.Item>
      </Form>
    </LoginWrapper>
  );
};

export default AuthorizationMobile;
